import { theme } from '@zappyrent/hundop';
import Media from 'react-media';

import Header from '../../components/Layout/Header';
import Main from '../../components/Layout/Main';
import Sidebar from '../../components/Layout/Sidebar';
import UserAvatar from '../../components/User/UserAvatar';
import UserDocuments from '../../components/User/UserDocuments';
import UserInfoPanel from '../../components/User/UserInfoPanel';
import UserPaymentsBankAccounts from '../../components/User/UserPayments';
import { UserTransferInstructions } from '../../components/User/UserTransferInstructions';
import UserType from '../../components/User/UserType';
import { useUser } from '../../shared/hooks';
import useUserDocuments from '../../shared/hooks/useUserDocuments';
import useStore from '../../store';
import { StyledWrapper } from './Profile.styles';

const Profile = (): JSX.Element | null => {
  const user = useStore(state => state.user);

  const isLoadingUser = useUser();
  const isLoadingUserDocuments = useUserDocuments(user?.id ?? null);

  return (
    <>
      {!isLoadingUser && !isLoadingUserDocuments && (
        <StyledWrapper>
          <Header />
          <Main>
            <UserAvatar />
            <UserType />
            <Media
              queries={{
                mobile: `(max-width: calc(${theme.breakpoints.l} - 1px))`,
              }}
            >
              {matches => matches.mobile && <UserInfoPanel />}
            </Media>
            <UserDocuments />
            {user?.type === 'landlord' && <UserPaymentsBankAccounts />}
            {user?.type === 'tenant' && <UserTransferInstructions />}
          </Main>
          <Sidebar>
            <Media
              queries={{
                desktop: `(min-width: ${theme.breakpoints.l})`,
              }}
            >
              {matches => matches.desktop && <UserInfoPanel />}
            </Media>
          </Sidebar>
        </StyledWrapper>
      )}
    </>
  );
};

export default Profile;
